module.exports = __webpack_public_path__ + "static/media/sairam.676fd077.svg";